import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

interface DragEvent extends MouseEvent {
	readonly dataTransfer: DataTransfer | null;
}

@Directive({
    selector: '[fileUploadDragAndDrop]',
    standalone: true,
})
export class FileUploadDragAndDropDirective {
	@HostBinding('class.linq-file-upload--active') fileOver: boolean;
	@HostBinding('class.linq-file-upload--error') hasError: boolean;
	@Output() fileDropped = new EventEmitter<any>();

	@HostListener('dragover', ['$event']) onDragOver(event: DragEvent): void {
		event.preventDefault();
		event.stopPropagation();
		this.fileOver = true;
	}

	@HostListener('dragleave', ['$event']) public onDragLeave(event: DragEvent): void {
		event.preventDefault();
		event.stopPropagation();
		this.fileOver = false;
	}

	@HostListener('drop', ['$event']) public ondrop(event: DragEvent): void {
		event.preventDefault();
		event.stopPropagation();
		this.fileOver = false;
		const files = event.dataTransfer.files;
		if (files.length > 0) {
			this.fileDropped.emit(files);
		}
	}

	// If a user clicks anywhere inside the file upload trigger a label click
	// The label click opens the native file picker
	@HostListener('click', ['$event']) public onClick(event: Event): void {
		if ((event.target as HTMLElement).nodeName.toLowerCase() !== 'label') {
			const parent = (event.target as HTMLElement).closest('.linq-file-upload');
			this.clickLabelIfExist(parent);
		}
	}

	// If a user enter when the element is focused trigger a label click
	// The label click opens the native file picker
	@HostListener('keypress', ['$event']) public onKeyPress(event: KeyboardEvent): void {
		if (event.code.toLowerCase() === 'enter') {
			const parent = (event.target as HTMLElement).closest('.linq-file-upload');
			this.clickLabelIfExist(parent);
		}
	}

	clickLabelIfExist(parent: Element): void {
		const label = parent?.querySelector('label');

		if (label) {
			label.click();
		}
	}
}
